<template>
  <div
    id="request-a-demo"
    :class="[
      background &&
        'bg-banner rounded-3xl py-12.5 md:py-[70px] xl:py-[120px] bg-primary-purple-50 bg-cover',
      !hideContentSection && 'container mx-auto flex items-center justify-center',
    ]"
  >
    <div
      class="xl:gap-25 max-w-[900px] lg:gap-10 md:gap-7 gap-5 flex md:flex-row flex-col-reverse justify-between items-center"
    >
      <div :class="[hideContentSection ? 'w-full' : 'w-full md:w-1/2']">
        <form class="w-full mx-auto">
          <div class="flex flex-col">
            <!-- Name -->
            <UiInputBox
              v-model="requestDemo.first_name"
              name="Name"
              title="Name"
              placeholder="Name"
              rules="required"
              type="text"
              :error-message="errors['first_name']"
              :check-is-data-valid="startValidation"
              @emitError="setError($event, 'first_name')"
            />
            <!-- Email -->
            <UiInputBox
              v-model="requestDemo.email"
              type="email"
              name="Email"
              title="Email"
              placeholder="Email"
              rules="required|email"
              :error-message="errors['email']"
              :check-is-data-valid="startValidation"
              @emitError="setError($event, 'email')"
            />
            <!-- Message box -->
            <UiInputBox
              v-model="requestDemo.message"
              placeholder="MSG"
              type="textarea"
              title="Message"
            />
          </div>
          <!-- Request a demo  -->
          <button
            :disablepd="isLoading"
            class="md:text-lg leading-6 text-sm font-inter font-semibold w-full h-12 sm:h-[60px] focus:outline-none focus:shadow-md text-white flex justify-center items-center primary-button"
            type="button"
            @click="sumbitForm"
          >
            <span v-i18n="landingPage">REQ_DEMO</span>
          </button>
        </form>
      </div>

      <div v-if="!hideContentSection" class="flex flex-col text-start gap-2.5 md:w-1/2 lg:gap-6">
        <h2>Book a Free Demo</h2>
        <p1 v-i18n="landingPage">DEMO_DESCP</p1>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_API_URL, ADMIN_API_URL } from '@services/.env'
import UiInputBox from '@src/views/SignUpPage/UiInputBox.vue'

export default {
  components: { UiInputBox },
  props: {
    background: {
      type: Boolean,
      default: false,
    },
    hideContentSection: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      landingPage: 'landingPage',
      startValidation: false,
      requestDemo: {
        first_name: '',
        email: '',
        message: '',
      },
      errors: {
        first_name: '',
        email: '',
      },
    }
  },
  methods: {
    setError(error, key, subKey) {
      if (subKey) this.errors[key][subKey] = error
      else this.errors[key] = error
    },
    sumbitForm() {
      this.startValidation = true
      let isValid = false
      setTimeout(() => {
        Object.entries(this.errors).forEach(([key, value]) => {
          if (value !== '' && typeof value !== 'object') isValid = true
          else if (typeof value === 'object') {
            Object.entries(value).forEach(([subKey, subValue]) => {
              if (subValue !== '') isValid = true
            })
          }
        })
        if (isValid) return
        this.submitRequestDemo()
      }, 0)
    },

    submitRequestDemo() {
      this.isLoading = true

      fetch(`${BASE_API_URL}${ADMIN_API_URL}demo_requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.requestDemo),
      })
        .then((response) => {
          this.$store.commit('NEW', {
            type: 'success',
            message: this.$t(`toast.REQUESTED_A_DEMO_ACCEPTED`),
          })

          this.resetFormData()
        })
        .catch((error) => {
          let err = error.response.data.error
          this.$store.commit('NEW', {
            type: 'error',
            message: err?.message || 'Pardon us for interuption',
          })
        })
        .finally(() => (this.isLoading = false))
    },
    resetFormData() {
      this.requestDemo = {
        first_name: null,
        email: null,
        message: null,
      }
      this.startValidation = false
    },
  },
}
</script>

<style scoped>
.btn-green {
  background: transparent linear-gradient(256deg, #0f9f5d 0%, #09814a 100%) 0% 0% no-repeat
    padding-box;
  border-radius: 38px;
}
</style>